import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "shared/utils/fetch-api";
import parseToTimestamp from "shared/utils/parseToTimestamp";

export const fetchPaymentSchedule = createAsyncThunk(
    'contract/fetchPaymentSchedule',
    async ({ idCase }: { idCase: string }, { rejectWithValue }) => {
        try {
            const response = await getRequest({ 'ContractID': idCase }, 'dms-hr', 'getPaymentSchedule', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { paymentSchedule: data.PaymentSchedule, idCase, fetchTime: parseToTimestamp(new Date()) };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error : any) {
            return rejectWithValue(error.message);
        }
    }
);

export const onFetchBill = async (idCase: string, setLoading: (isLoading: boolean) => void, setOpen: (isLoading: boolean) => void) => {
    setLoading(true);
    try {
        const response = await  getRequest({ 'ContractID': idCase }, 'dms-hr', 'getBill', 'POST')
        const data = await response.json();
        if (data.Errors.length === 0) {
            setOpen(true);
            setLoading(false);
            return data.Task
        } else {
            setLoading(false);
            return data.Errors
        }
    } catch (error) {
        console.error('Ошибка сервиса: ', error);
        setLoading(false);
        throw error; 
    }
}